<template>
  <div>
    <v-carousel
      :interval="limitMs"
      :height="$vuetify.breakpoint.xsOnly ? 'auto' : 325"
      hide-delimiters
      :show-arrows="false"
      ref="carousel"
      :style="smAndDown ? 'aspect-ratio: 1.96666666666; min-height: 150px;' : null"
      touchless
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        reverse-transition="slide-x-transition"
        transition="slide-x-transition"
      >
        <v-img
          class="mx-auto"
          :src="slide.img"
          :alt="slide.title"
          eager
          @click="next()"
          width="100%"
          max-width="639"
          :aspect-ratio="smAndDown ? 1.96666666666 : null"
        >
          <slot name="title"></slot>
        </v-img>
      </v-carousel-item>
    </v-carousel>

    <v-stepper
      v-model="current_slide"
      tile
      flat
      elevation="0"
    >
      <v-stepper-header class="justify-center align-center">
        <template v-for="index of slides.length">
          <v-stepper-step :step="index" :key="index" @click="current(index)" color="grey darken-4"
                          class="slider-number pa-0"/>
          <div v-if="slides.length !== index" class="bar"><span :ref="'progressBar' + index"></span></div>
        </template>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
export default {
  name: 'stepSlideImage',
  props: {
    slides: {
      type: Array,
      required: true,
      default: [],
    }
  },
  data: function () {
    return {
      current_slide: 1,
      timer: null,
      limitMs: 5000,
      restMs: 0,
      resolutionMs: 50,
      maxBar: 100,
    }
  },
  methods: {
    next() {
      this.current_slide++;
      if (this.current_slide === this.slides.length + 1) {
        this.current_slide = 1;
      }
      this.$refs.carousel.$data.internalLazyValue = this.current_slide - 1;
      this.$emit('active-number', this.current_slide);
      this.onTimer();
    },
    current(i) {
      this.$refs.carousel.$data.internalLazyValue = i - 1;
      this.$emit('active-number', i);
      this.current_slide = i;
      this.onTimer();
    },
    onTimer() {
      const self = this;
      this.resetTimer();
      this.timer = setInterval(function () {
        self.countdown()
      }, 50);
    },
    offTimer() {
      if (this.timer === null) {
        this.onTimer();
      } else {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    countdown() {
      this.restMs -= this.resolutionMs;
      const restRate = (this.limitMs - this.restMs) / this.limitMs;
      const restBarLength = this.maxBar * restRate;

      if (this.$refs['progressBar' + this.current_slide]) {
        this.$refs['progressBar' + this.current_slide][0].style.width = restBarLength + '%';
      }

      if (this.restMs < 0) {
        this.offTimer();
        this.next();
        this.limitMs = this.restMs = 5000;
      }
    },
    resetTimer() {
      clearInterval(this.timer);
      this.limitMs = this.restMs = 5000;
      this.slides.map((_, i) => {
        if (this.$refs['progressBar' + (i + 1)]) {
          this.$refs['progressBar' + (i + 1)][0].style.width = 0;
        }
      });
    },
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted: function () {
    this.onTimer();
  },
  beforeDestroy() {
    this.resetTimer();
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .slider-number {
    .v-stepper__step__step {
      width: 18px;
      min-width: auto;
      height: 18px;
      font-size: 11px;
      cursor: pointer;
      margin: 0 !important;
      font-weight: bold;
    }
  }

  .v-stepper__step {
    &:not(.v-stepper__step--active) {
      &:not(.v-stepper__step--complete) {
        &:not(.v-stepper__step--error) {
          .v-stepper__step__step {
            background-color: #EAEAEA !important;
            color: #2C2C2C;
          }
        }
      }
    }
  }

  .bar {
    border: 0;
    height: 2px;
    width: 3.125em;
    background: #EAEAEA;

    span {
      width: 0;
      height: 2px;
      display: block;
      background: #2c2c2c;
    }
  }
}
</style>